import * as _ from 'lodash';
import { differenceStatusSetType } from 'src/shared/enums/difference-status-calibration-type.enum';

export class BaseChangesTable {
    getCalibrationStatusType(typeId) {
        return differenceStatusSetType[typeId];
    }

    isExist(value) {
        if (value) {
            const nameField = Object.keys(value)[0];
            return !!value[nameField];
        }
    }
}
